import chance from '@/modules/base/services/chance';
import {PositionEnum} from "@/modules/base/enums";
import {inject, injectable} from "inversify";
import {YouthPlayer} from "@/modules/youth/entity";
import CountryRandomizer from "@/modules/base/services/CountryRandomizer";
import {Team} from "@/modules/team/entity";
import YouthPlayerWageCalculator from "@/modules/youth/services/YouthPlayerWageCalculator";
import MarketValueCalculator from "@/modules/team/services/MarketValueCalculator";

@injectable()
export default class NewcomerYouthPlayerFactory {
  constructor(
    @inject(CountryRandomizer) private countryRandomizer: CountryRandomizer,
    @inject(YouthPlayerWageCalculator) private youthPlayerWageCalculator: YouthPlayerWageCalculator,
    @inject(MarketValueCalculator) private marketValueCalculator: MarketValueCalculator,
  ) {}

  async make(team: Team): Promise<YouthPlayer> {
    const p = new YouthPlayer();

    p.team = team;
    p.name = `${chance.first()} ${chance.last()}`;
    p.age = chance.integer({min: 15, max: 21});
    p.skill = chance.integer({min: 1, max: 40});
    p.talent = chance.integer({min: 1, max: 100});
    p.revelation = chance.integer({min: 1, max: 100});
    p.position = chance.randomEnum(PositionEnum);

    if (chance.bool({likelihood: 80})) {
      p.country = team.country;
    } else {
      p.country = await this.countryRandomizer.one(team.country.region);
    }

    p.patience = chance.integer({min: 1, max: 100});
    p.greediness = chance.integer({min: 1, max: 100});
    p.resentfulness = chance.integer({min: 1, max: 100});
    p.baseMonthlyPrice = chance.integer({min: 1000, max: 2000});
    p.baseOncePrice = chance.integer({min: 1000, max: 2000});
    p.wage = this.youthPlayerWageCalculator.calculate(p);
    p.marketValue = await this.marketValueCalculator.calculate(p);

    return p;
  }
}
